/*
 *
 * File JS Principale
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import 'lightgallery/css/lightgallery-bundle.min.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'scss/app.scss';
//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    typekit: {
        id: 'ist0ong',
    },
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Libreria JS per l'output stilizzato per gli snippet di codice
//--------------------------------------------------------------------//

// import hljs from 'highlight.js';
// import 'highlight.js/styles/vs2015.css';
// hljs.highlightAll();

// let MobileDetect = require('mobile-detect');
// let md = new MobileDetect(window.navigator.userAgent);

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

//--------------------------------------------------------------------//

// Import Componenti
//--------------------------------------------------------------------//
import initHeader from 'components/header/header';
import animateIn from 'animations/animate-in/animate-in';
import modal from 'imComponents/modal/modal';
import accordion from 'imComponents/accordion/accordion';
import button from 'components/buttons/buttons';
import marquee from 'components/marquee/marquee';

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//

if (!document.querySelector('body.wp-admin')) {
    initHeader();
    animateIn();
    modal();
    accordion();
    marquee();
}
